module.exports = __webpack_public_path__ + "static/media/kgfj.efa0a21f.jpg";